import React from 'react';
import Header from './header';
import Features from './sectionOne';
import SectionTwo from './sectionTwo';
// import SectionThree from './sectionThree';
import SectionFour from './sectionFour';
import SectionFive from './sectionFive';
import Footer from '../../Layouts/Footer';

const LandingPage = () => {
  return (
    <div>
      <Header />
      <Features/>
      <SectionTwo />
      {/* <SectionThree /> */}
      <SectionFour />
      <SectionFive />
      <Footer />
    </div>
  );
};

export default LandingPage;
